import HTTPError from '../HTTPError';
class BadGateway extends HTTPError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 502;
        super(status, ...args);
    }
}
export default BadGateway;
